import { RefertoContext } from "app/context/RefertoContext";
import { dataDaSlashaDash } from "app/utility/dataOra";
import React, { useContext, useState } from "react";
import { NotificationManager, NotificationContainer } from "react-notifications";

const Complicanze = ({ complicanze }) => {
    const [complicazioni, setComplicazioni] = useState(complicanze.complicazioni);
    const [records, setRecords] = useState(complicanze.dettaglio);
    const [errors, setErrors] = useState([{ effectiveTimeLow: false, effectiveTimeHigh: false, nota: false }]);
    const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
    const addRecord = () => {
        setRecords([...records, { effectiveTimeLow: "", effectiveTimeHigh: "", nota: "" }]);
        setErrors([...errors, { effectiveTimeLow: false, effectiveTimeHigh: false, nota: false }]);
    };

    const updateRecord = (index, field, value) => {
        const newRecords = [...records];
        newRecords[index][field] = value;
        setRecords(newRecords);
    };

    const deleteRecord = (index) => {
        const newRecords = records.filter((_, i) => i !== index);
        const newErrors = errors.filter((_, i) => i !== index);
        setRecords(newRecords);
        setErrors(newErrors);
    };

    const validateRecords = () => {
        let valid = true;
        const newErrors = records.map((record) => {
            const recordErrors = {
                effectiveTimeLow: !record.effectiveTimeLow,
                effectiveTimeHigh: !record.effectiveTimeHigh,
                nota: !record.nota,
            };
            if (recordErrors.effectiveTimeLow || recordErrors.effectiveTimeHigh || recordErrors.nota) {
                valid = false;
            }
            return recordErrors;
        });
        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = () => {
        NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
        if (!complicazioni.trim()) {
            NotificationManager.warning("Il campo complicazioni è obbligatorio", "Attenzione");
            return;
        }
        if (!validateRecords()) {
            NotificationManager.warning("Tutti i campi di osservazione sono obbligatori", "Attenzione");
            return;
        }
        NotificationManager.success("Salvataggio avvenuto con successo", "Salva");
        const payload = {
            complicazioni,
            dettaglio: records,
        };
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "complicanze",
            payload: payload
        });
    };

    const handleCancella = () => {
        const record = [{ effectiveTimeLow: "", effectiveTimeHigh: "", nota: "" }];
        const payload = {
            complicazioni: "",
            dettaglio: record,
        };
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "complicanze",
            payload: payload
        });

        setRecords(record);
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "complicanze",
            payload: ""
        });
        setErrors([{ effectiveTimeLow: false, effectiveTimeHigh: false, nota: false }]);
    }

    return (
        <div className="container mt-4">
            <div className="mb-3">
                <h5 className="mb-2">Complicazioni</h5>
                <textarea
                    className="form-control"
                    rows="3"
                    value={complicazioni}
                    onChange={(e) => setComplicazioni(e.target.value)}
                ></textarea>
            </div>
            {records.map((record, index) => (
                <div className="mb-3" key={index}>
                    <div className="d-flex justify-content-between">
                        <h5 className="mb-2">{index + 1}) Osservazione</h5>
                        {index > 0 &&
                            <button className="btn btn-danger text-white"
                                title="Elimina osservazione"
                                onClick={() => deleteRecord(index)}>
                                x
                            </button>
                        }
                    </div>
                    <div className="d-flex d-flex justify-content-start">
                        <div className="col-2 mx-3">
                            <label className="form-label">Data Inizio</label>
                            <input
                                type="date"
                                className="form-control"
                                value={dataDaSlashaDash(record.effectiveTimeLow)}
                                onChange={(e) => updateRecord(index, "effectiveTimeLow", e.target.value)}
                            />
                        </div>
                        <div className="col-2">
                            <label className="form-label">Data Fine</label>
                            <input
                                type="date"
                                className="form-control"
                                value={dataDaSlashaDash(record.effectiveTimeHigh)}
                                onChange={(e) => updateRecord(index, "effectiveTimeHigh", e.target.value)}
                            />
                        </div>

                    </div>
                    <div className="d-flex justify-content-start mt-2">
                        <div className="mb-2 col-12">
                            <label className="form-label">Note</label>
                            <textarea
                                className="form-control"
                                rows="2"
                                value={record.nota}
                                onChange={(e) => updateRecord(index, "nota", e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    <hr className="bg-primary" />
                </div>
            ))}
            <div className="mt-3 d-flex justify-content-between">
                <button className="btn btn-primary" onClick={handleSubmit}>
                    Conferma
                </button>
                <button className="btn btn-secondary mx-3" onClick={addRecord}>
                    Aggiungi osservazione
                </button>
                <button type="button" className="btn btn-danger text-white" onClick={handleCancella}>
                    Cancella
                </button>
            </div>
            <NotificationContainer />
        </div>
    );
};

export default Complicanze;
